














import { currencySymbols } from '@/utils/currencySymbols'
import Vue, { PropType } from 'vue'

export interface BalanceItem {
  USD: string
  CUP: string
  MLC: string
  MLX: string
  EUR: string
  [key: string]: string
}

export default Vue.extend({
  props: {
    balance: Object as PropType<BalanceItem>,
  },
  data() {
    return {
      currencySymbols: currencySymbols as { [key: string]: string },
      colors: ['green', 'cyan', 'pink', 'purple', 'lime'],
    }
  },
  computed: {
    values(): object[] {
      return Object.entries(this.balance).map(([key, value], index) => ({
        key,
        value: Number(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
        }),
        color: this.colors[index],
      }))
    },
  },
})
